import { assert_nested_coords } from "../MapViewController";
import { SkNodeDisplayItem } from "../stek/sk-display";
import { addCoordinatesOperation, addFloorGetSet, addFloorObjProps, B_AttrFlags, BBase, kFloorZBias, kOnFloorItemZBias, register_b_class } from "./BBase";

class BNode extends addCoordinatesOperation(addFloorGetSet(BBase)) {
	constructor(flags, forceSetId) {
		super(flags, forceSetId);
		addFloorObjProps(this);

		this.mapFeautre = null;
		this.editorFeatures = null;

		this.geometryType = "Point";
	}

	serialize() {
		const o = super.serialize();
		o.coordinates = this.coordinates;

		return o;
	}

	deserialize(o) {
		assert_nested_coords(o.coordinates);
		this.copyAllCoordinates(o.coordinates);

		this.saveCoordinates();
		this.updateXyCoordinates();
	}

	getSingleCoord() {
		return this.coordinates[0][0];
	}

	generateDisplayList(outList) {
		if (!this.floor) {
			console.log("%c[WARNING] Floor is not set.", "color:#F09");
			return;	
		}

		if (this.flags & B_AttrFlags.ElevatorNode) {
			const nextFloor = get_next_floor(this);
			if (!nextFloor) { return; }

			const d = new SkNodeDisplayItem();
			d.useLocalTransform();
			this.floor.connectTransformTreeItemIf(d);

			d.vpool.resize(2);

			const v1 = d.vpool.at(0);
			const v2 = d.vpool.at(1);

			const alt_diff = nextFloor.floorAltitude - this.floor.floorAltitude;

			const point_coord = this.getSingleCoord();
			v1.pos.set3d(point_coord[1], point_coord[0], 0); // lat(x)=1, lng(y)=0
			v2.pos.set3d(point_coord[1], point_coord[0], alt_diff);

			d.sortKey = this.floor.stackOrder * kFloorZBias + kOnFloorItemZBias;
			outList.push(d);
		}
	}
}

function generateNodeIcon(w, h, pixelRatio) {
	const canvas = document.createElement("canvas");
	w *= pixelRatio;
	h *= pixelRatio;

	canvas.width = w;
	canvas.height = h;

	const g = canvas.getContext("2d");
	const r = (w >> 1) - (pixelRatio << 2);

	const x = w >> 1;
	const y = h >> 1;

	const gradient = g.createRadialGradient(x, y * 0.8, pixelRatio, x, y, r);
	gradient.addColorStop(0, "#cdf");
	gradient.addColorStop(0.4, "#17f");
	gradient.addColorStop(1, "#148");

	g.fillStyle = gradient;
	g.beginPath();
	g.arc(x, y, r, 0, Math.PI*2, false);
	g.fill();

	return canvas.toDataURL();
}

function get_next_floor(bitem) {
	return bitem.floor?.getParent()?.getNextFloorOf?.( bitem.floor ) ?? null;
}

register_b_class(BNode);
export { generateNodeIcon, get_next_floor };
export default BNode;